export default {
  services: [],
  servicesCount: 0,
  query: {},
  limit: 10,
  skip: 0,
  sort: {}
}
